import { useMutation } from "@tanstack/react-query";
import { ApiService } from "@/services/api/ApiService";
import {
  GenerateGenieDocumentInput,
  GenerateGenieDocumentResult,
} from "@/types/genie-documents/genie-document";

/**
 * Generate a co-branded document from a genie's knowledge base.
 * Simple single-call mutation — no Service layer needed (nothing to abstract).
 */
export const useGenerateGenieDocument = () => {
  return useMutation<GenerateGenieDocumentResult, Error, GenerateGenieDocumentInput>({
    mutationFn: async (input) =>
      ApiService.invoke<GenerateGenieDocumentResult>({
        resource: "genie-documents",
        action: "generate",
        data: {
          agentId: input.agentId,
          template: input.template,
          purpose: input.purpose,
          documentIds: input.documentIds,
          genieName: input.genieName,
        },
      }),
  });
};
